import { createFileRoute, redirect } from '@tanstack/react-router';

// The public integrations directory was replaced by the catalog in our docs. Old links
// (`/integrations`, `/integrations/<type>`) land there without needing a session.
const INTEGRATIONS_CATALOG_URL = 'https://docs.customer.io/integrations/catalog/';

export const Route = createFileRoute('/integrations/$')({
  beforeLoad: () => {
    throw redirect({ href: INTEGRATIONS_CATALOG_URL, replace: true });
  },
});
